import { render, staticRenderFns } from "./BandejaInvisaling.vue?vue&type=template&id=3134376e"
import script from "./BandejaInvisaling.vue?vue&type=script&lang=js"
export * from "./BandejaInvisaling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports